var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lazyImage",staticClass:"lazy-image",style:(_vm.imageStyles),attrs:{"title":_vm.alt || _vm.title}},[(_vm.link)?_c('a',{staticClass:"link",attrs:{"href":_vm.link}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }